import React from 'react'
import Layout from '../../common/Layout'
import AdviserSearchResultsListContainer from '../../features/AdviserSearchResultsListContainer'

export default {
  
  path: '/search-results',
  children: [{
      path: '/',
      async action({ query }) {
        const urlSearchCriteria = query.adviserName
          ? { adviserName: query.adviserName }
          : {}

        return {
          title: 'Search Results',
          component: (
            <Layout backButtonText="Back to search">
              <AdviserSearchResultsListContainer
                urlSearchCriteria={urlSearchCriteria}
                isDetailedSearch={false}
                currentSort="relevance"
              />
            </Layout>
          )
        }
      }
    },
    {
      path: '/:adviserName',
      async action({ params }) {
        const { adviserName } = params
        const urlSearchCriteria = { adviserName }

        return {
          title: 'Search Results',
          component: (
            <Layout backButtonText="Back to search">
              <AdviserSearchResultsListContainer
                urlSearchCriteria={urlSearchCriteria}
                isDetailedSearch={false}
                currentSort="relevance"
              />
            </Layout>
          )
        }
      }
    }, {
      path: '/criteria/:criteriaString',
      async action({ params }) {
        const { criteriaString } = params
        const urlSearchParams = new URLSearchParams(criteriaString)

        const urlSearchCriteria = {
          investorDescriptionId: urlSearchParams.get('investorDescriptionId'),
          investmentAmounts: {
            onceOffAmount: urlSearchParams.get('lumpSum'),
            monthlyAmount: urlSearchParams.get('debitOrder')
          },
          financialServices: urlSearchParams.get('financialServices')
            ? urlSearchParams.get('financialServices').split(',')
            : [],
          selectedPreferredLanguageIds: urlSearchParams.get('languagePreferences')
            ? urlSearchParams.get('languagePreferences').split(',')
            : [],
          userAddress: urlSearchParams.get('location')
        }
        return {
          title: 'Search Results',
          component: (
            <Layout backButtonText="Back to search">
              <AdviserSearchResultsListContainer
                urlSearchCriteria={urlSearchCriteria}
                isDetailedSearch
                currentSort="relevance"
              />
            </Layout>
          )
        }
      }
    }]
}
